import {useRouteQuery} from '@vueuse/router';

export default function useMonadicRouteQuery(name: string) {
	const query = useRouteQuery(name);

	return computed({
		get(): string | null {
			return query.value === null || query.value === undefined
				? null
				: typeof query.value === 'string'
					? query.value
					: query.value[0];
		},
		set(value: string | null) {
			const newValue = value || null;

			if (query.value !== newValue) {
				query.value = newValue;
			}
		},
	});
}
